import { useEffect, useState } from 'react';
import RedirectSubdomainPicker from './RedirectSubdomainPicker';
import DomainStatus from './DomainStatus';

export default function AddDomainWizard(props) {
  const [validCname, setValidCname] = useState(undefined);
  const [validCnameWww, setValidCnameWww] = useState(undefined);

  async function checkDns(domain, blogId, isWww) {
    try {
      const response = await fetch('/api/check-dns', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          domain: isWww ? `www.${domain}` : domain,
          targetCname: `${blogId}.truvvl.blog`,
        }),
      });

      const data = await response.json();
      if (isWww) setValidCnameWww(data.success);
      else setValidCname(data.success);
      return data;
    } catch (err) {
      return false;
    }
  }

  function runDnsCheck(domainUrl, blogId) {
    const domain = domainUrl.replace(/^https?:\/\/(www\.)?/, '');
    checkDns(domain, blogId);
    checkDns(domain, blogId, true);
  }

  useEffect(() => {
    runDnsCheck(props.blog.domain, props.blogId);
  }, []);

  return (
    <>
      <DomainStatus
        {...props}
        validCname={validCname}
        validCnameWww={validCnameWww}
      />
      {(validCname || validCnameWww) && <RedirectSubdomainPicker {...props} />}
    </>
  );
}
